import {Component, OnInit} from '@angular/core';
import {MessageService} from 'primeng/api';
import {TableModule} from 'primeng/table';
import {compareTimeslotStartEnd} from '../components/Utils';
import {UserErrors} from '../models';
import {MiniBookAdminService} from '../service/mini-book-admin.service';
import {Timeslot} from '../shared/Timeslot';

@Component({
    selector: 'edu-udo-itmc-dev-mini-book-timeslots',
    templateUrl: './timeslots.component.html',
    styleUrls: ['./timeslots.component.css'],
    standalone: false
})
export class TimeslotsComponent implements OnInit {

  timeslots: Timeslot[] = [];
  timeslotErrors?: UserErrors;
  timeslotInError?: Timeslot;

  targetDate!: Date;
  targetDateEnd?: Date;

  clonedTimeslot?: Timeslot;

  editing: boolean = false;

  rowTrackBy = (timeslot: Timeslot) => timeslot.id;

  constructor(
    private adminService: MiniBookAdminService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.adminService.timeslots.getTimeslots().subscribe({
      next: value => this.timeslots = value
    });
    this.adminService.generalConfig.getGeneralConfig().subscribe({
      next: value => {this.targetDate = value.targetDate; this.targetDateEnd = value.targetDateEnd;}
    })
  }

  change(timeslot: Timeslot, input: any) {
    if (typeof input === 'string' && !input.startsWith('0')) {
      let inputArray = input.split('-').map((value: string) => +value);
      timeslot.date = new Date(inputArray[0], inputArray[1] - 1, inputArray[2]);
    }
  }

  createTimeslot(table: any) {
    const newTimeslot = new Timeslot();
    newTimeslot.date = new Date(this.targetDate);
    this.timeslots.push(newTimeslot);
    table.initRowEdit(newTimeslot);
    this.editing = true;
  }

  updateTimeslot(timeslot: Timeslot) {
    if (this.clonedTimeslot) {
      this.adminService.timeslots.updateTimeslot(timeslot.id, timeslot).subscribe({
        next: value => {
          timeslot.fromJson(value.toJson());
          this.messageService.add({
            summary: 'Änderungen wurden gespeichert.',
            severity: 'success'
          });
          this.timeslots.sort(compareTimeslotStartEnd);
        },
        error: err => {
          this.messageService.add({
            summary: 'Fehler bei der Kommunikation mit dem Backend',
            detail: err.message,
            severity: 'error'
          });
        }
      });
      this.clonedTimeslot = undefined;
    } else {
      this.adminService.timeslots.createTimeslot(timeslot).subscribe({
        next: value => {
          timeslot.fromJson(value.toJson());
          this.messageService.add({
            summary: 'Timeslot wurde hinzugefügt.',
            severity: 'success'
          });
          this.timeslots.sort(compareTimeslotStartEnd);
        },
        error: err => {
          this.messageService.add({
            summary: 'Fehler bei der Kommunikation mit dem Backend',
            detail: err.message,
            severity: 'error'
          });
        }
      });
    }
    this.editing = false;
  }

  deleteTimeslot(timeslot: Timeslot) {
    this.adminService.timeslots.deleteTimeslot(timeslot.id, false).subscribe({
      next: () => {
        this.timeslots = this.timeslots.filter(value => value.id !== timeslot.id);
        this.messageService.add({
          summary: 'Timeslot wurde entfernt.',
          severity: 'success'
        });
      },
      error: err => {
        this.timeslotInError = timeslot;
        if ('error' in err && typeof err.error == 'object' && 'type' in err.error && err.error.type === 'UserErrors') {
          this.timeslotErrors = err.error;
        } else {
          this.messageService.add({
            summary: 'Fehler bei der Kommunikation mit dem Backend',
            detail: err.message,
            severity: 'error'
          });
        }
      }
    });
  }

  onTimeslotEditInit(t: Timeslot) {
    this.clonedTimeslot = Timeslot.createFromJson(t.toJson());
    this.editing = true;
  }

  onTimeslotEditCancel(t: Timeslot) {
    if (this.clonedTimeslot) {
      t.fromJson(this.clonedTimeslot.toJson());
      this.clonedTimeslot = undefined;
    } else {
      this.timeslots = this.timeslots.filter(value => value.id !== 0);
    }
    this.editing = false;
  }

  checkTimeslot(timeslot: Timeslot): boolean {
    if (this.targetDate) {
      if (!this.targetDateEnd) {
        return timeslot.date.getTime() !== this.targetDate.getTime();
      } else {
        return timeslot.date.getTime() < this.targetDate.getTime() || timeslot.date.getTime() > this.targetDateEnd.getTime();
      }
    }
    return false;
  }

  clearTimeslotError(executeForced: boolean) {
    const timeslot = this.timeslotInError;
    this.timeslotErrors = undefined;
    this.timeslotInError = undefined;
    if (executeForced && timeslot) {
      this.adminService.timeslots.deleteTimeslot(timeslot.id, executeForced).subscribe({
        next: () => {
          this.timeslots = this.timeslots.filter(value => value.id !== timeslot.id);
          this.messageService.add({
            summary: 'Timeslot wurde entfernt.',
            detail: 'Entfernen des Timeslots wurde erzwungen.',
            severity: 'success'
          });
        },
        error: err => {
          this.messageService.add({
            summary: 'Fehler bei der Kommunikation mit dem Backend',
            detail: err.message,
            severity: 'error'
          });
        }
      });
    }
  }
}
